"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewRadioGroup = exports.NewRadio = void 0;
const react_1 = __importStar(require("react"));
const selector_1 = require("./icons/selector");
const radio_group_styles_1 = require("./radio-group.styles");
const radio_group_types_1 = require("./radio-group.types");
const RadioGroupContext = react_1.default.createContext({});
exports.NewRadio = (0, react_1.memo)(({ value, label, description, icon, iconPosition = radio_group_types_1.IconPosition.Right, showIcon = true, testId = 'radio-group', }) => {
    const { name, selectedValue, onChange } = (0, react_1.useContext)(RadioGroupContext);
    const selectedCurrentVal = value === selectedValue;
    return (react_1.default.createElement(radio_group_styles_1.StyledRadioButton, { iconPosition: iconPosition, htmlFor: value, checked: value === selectedValue },
        react_1.default.createElement("div", null,
            react_1.default.createElement("input", { type: "radio", id: value, name: name, value: value, checked: value === selectedValue, onChange: onChange.bind(null, value), "data-testid": `${testId}.input-${value}` }),
            react_1.default.createElement(radio_group_styles_1.StyledTitle, null, label),
            description && react_1.default.createElement(radio_group_styles_1.StyledDescription, null, description)),
        showIcon && (react_1.default.createElement(radio_group_styles_1.StyledIcon, { iconPosition: iconPosition, "data-testid": `${testId}.icon-${value}` }, icon ? (icon) : (react_1.default.createElement(radio_group_styles_1.StyledCircle, { iconPosition: iconPosition, selectedCurrentVal: selectedCurrentVal }, selectedCurrentVal && react_1.default.createElement(selector_1.Selector, null)))))));
});
exports.NewRadioGroup = (0, react_1.memo)((props) => {
    const { name, selectedValue, onChange, children } = props, rest = __rest(props, ["name", "selectedValue", "onChange", "children"]);
    const ctx = { name, selectedValue, onChange };
    return (react_1.default.createElement(RadioGroupContext.Provider, { value: ctx },
        react_1.default.createElement("div", Object.assign({}, rest), children)));
});
